import { LogIn, ShieldCheck } from "lucide-react";

const AdminLogin = () => {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4">
      <div className="w-full max-w-sm bg-card rounded-3xl border border-border shadow-xl p-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-4 text-primary-foreground font-bold text-xl font-heading">
          DP
        </div>
        <h1 className="text-xl font-bold font-heading text-foreground">Painel Administrativo</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">Divulga Pocinhos Guia</p>
        <button
          onClick={login}
          data-testid="admin-google-login"
          className="w-full flex items-center justify-center gap-2 bg-primary text-primary-foreground font-semibold rounded-full py-3 active:scale-95 transition-transform"
        >
          <LogIn className="w-5 h-5" /> Entrar com Google
        </button>
        <p className="text-xs text-muted-foreground mt-4 flex items-center justify-center gap-1">
          <ShieldCheck className="w-3.5 h-3.5" /> Acesso restrito ao administrador
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
